import Navbar from "../components/Navbar"
import ProjectsComponent from "../components/ProjectsComponent"
import Footer from "../components/Footer"
import SEOMetaTags from "../components/SEOMetaTags"

function Projects() {
  return (
    <div className="min-h-screen bg-white">
      <SEOMetaTags 
        title="Projelerimiz - Buğra Teknik Servis"
        description="Karabük'te tamamladığımız doğal gaz tesisatı, su tesisatı, kombi montajı ve diğer teknik servis projeleri. Referanslarımızı inceleyin."
      />
      <Navbar />
      <div className="pt-16">
        <ProjectsComponent />
      </div>
      <Footer />
    </div>
  )
}

export default Projects
